// src/App.js
import React, { useState, useEffect, useMemo } from 'react';
import { fetchJson } from './api';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Switch from '@mui/material/Switch';
import Avatar from '@mui/material/Avatar';
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
import CreateIcon from '@mui/icons-material/Create';
import PostPlanWizardPage from "./postplans/PostPlanWizardPage";
import LoginForm from './LoginForm';
import LoginPage from './LoginPage';
import RegistrationPage from './RegistrationPage';
import RegistrationForm from './RegistrationForm';
import CreateMaestranzaForm from './CreateMaestranzaForm';
import EditMaestranzaForm from './EditMaestranzaForm';
import EditProfileForm from './EditProfileForm';
import ProductionHouseView from './ProductionHouseView';
import FreelancerDetailView from './FreelancerDetailView';
import CookieBanner from './CookieBanner';
import PrivacyPage from './PrivacyPage';
import DisponibilePage from './DisponibilePage';
import AdminToolsPage from './AdminToolsPage';
import CoordinatorsPage from './CoordinatorsPage';
import SupervisorAlertsPage from './SupervisorAlertsPage';
import NotifichePage from './NotifichePage';
import PreferitiPage from './PreferitiPage';
import RadarDisponibilitaPage from './RadarDisponibilitaPage';
import FreelancerPublicView from './FreelancerPublicView';
import FreelancerProfileRoute from "./FreelancerProfileRoute";
import MissingProfileIdDialog from './MissingProfileIdDialog';
import AlertsBoard from './AlertsBoard'; // oppure './components/AlertsBoard'
import FreelancerAlertsPanel from './FreelancerAlertsPanel';
import FreelancerProfile from './FreelancerProfile';
import LandingPage from './LandingPage';
import ContactPage from './ContactPage';
import PremiumPage from './PremiumPage';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Chip from '@mui/material/Chip';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ReviewPlayerPage from './review/ReviewPlayerPage';
import ReviewNotesPage from './review/ReviewNotesPage';
import PostPlanAssistPage from "./postplans/pages/PostPlanAssistPage";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import PlansListPage from "./postplans/pages/PlansListPage";
import PlanEditor from "./postplans/pages/PlanEditor";
import StepSetup from "./postplans/pages/StepSetup";
import StepEpisodes from "./postplans/pages/StepEpisodes";
import StepRoles from "./postplans/pages/StepRoles";
import StepConstraints from "./postplans/pages/StepConstraints";
import StepReview from "./postplans/pages/StepReview";
import TimelineView from "./postplans/components/TimelineView";
import SquadrePage from "./squadre/SquadrePage";
import CreatePlanPage from "./postplans/CreatePlanPage";
import EventsPage from "./EventsPage";
import EventNewPage from "./EventNewPage";
import EventDetailPage from "./EventDetailPage";
import EventEditPage from "./EventEditPage";
import ReviewDashboard from "./review/ReviewDashboard";
import ProductionDashboard from './productions/ProductionDashboard';
import ProductionsList from './productions/ProductionsList';
import ReviewPublicPage from './review/ReviewPublicPage';
import PostPlanTimelinePage from "./pages/PostPlanTimelinePage";
import MessagesPage from "./MessagesPage";
import AppShell from "./AppShell";
import CercaFreelancePage from "./CercaFreelancePage";
import PendingApprovalPage from './PendingApprovalPage';
import ResetPasswordPage from './ResetPasswordPage';
import TerminiPage from './TerminiPage';
import PianoDiPost from './PianoDiPost';
import MieiCreditiPage from './MieiCreditiPage';
// 🔎 DEBUG ROUTE WRAPPER (temporaneo)
function DebugElement({ name, children }) {
  console.log("🧭 ROUTE LIVE:", name);
  return children;
}

const StyledListItem = styled('li')(() => ({
  display: 'grid',
  gridTemplateColumns: '1.2fr 1.5fr 1.5fr 1.5fr 0.8fr 1fr',
  gap: '15px',
  padding: '15px 20px',
  borderBottom: '1px solid #444',
  alignItems: 'center',
  backgroundColor: '#282c34',
  color: '#e0e0e0',
  '&:last-child': { borderBottom: 'none' },
  '& .MuiTypography-root': { color: '#bbb' },
}));

const StyledList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: '20px 0',
  backgroundColor: '#2e323a',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
});


// ── ProfileGate — blocca le route se profilo nascosto o incompleto ──
function ProfileGate({ freelancerProfile, children }) {
  if (!freelancerProfile) return children;

  console.log('[ProfileGate] profile:', freelancerProfile);
  const isHidden = freelancerProfile.visible === false;
  const hasRuolo = Array.isArray(freelancerProfile.ruoli) && freelancerProfile.ruoli.length > 0;
  const hasProduzione = (Array.isArray(freelancerProfile.maestranze) && freelancerProfile.maestranze.length > 0) || (typeof freelancerProfile.maestranze === 'number' && freelancerProfile.maestranze > 0);
  const isIncomplete = !hasRuolo || !hasProduzione;

  if (!isHidden && !isIncomplete) return children;

  const reason = isHidden
    ? { title: 'Profilo nascosto', msg: 'Hai impostato il tuo profilo come non visibile. Rendilo visibile per accedere a tutte le funzioni.' }
    : { title: 'Profilo incompleto', msg: `Per accedere a tutte le funzioni devi completare il profilo con: ${!hasRuolo ? 'almeno un ruolo' : ''}${!hasRuolo && !hasProduzione ? ' e ' : ''}${!hasProduzione ? 'almeno una produzione' : ''}.` };

  return (
    <div style={{
      minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px'
    }}>
      <div style={{
        maxWidth: '480px', textAlign: 'center',
        background: 'rgba(212,165,80,0.06)', border: '1px solid rgba(212,165,80,0.25)',
        borderRadius: '16px', padding: '40px 32px'
      }}>
        <div style={{ fontSize: '36px', marginBottom: '16px' }}>🔒</div>
        <h2 style={{ fontFamily: 'Kanit, sans-serif', color: '#d4a550', letterSpacing: '0.05em', marginBottom: '12px' }}>
          {reason.title}
        </h2>
        <p style={{ color: '#a0a0b0', lineHeight: 1.6, marginBottom: '24px', fontSize: '14px' }}>
          {reason.msg}
        </p>
        <a href="/profile" style={{
          display: 'inline-block', background: '#d4a550', color: '#0b0d13',
          borderRadius: '8px', padding: '10px 24px', fontWeight: 700,
          fontFamily: 'Kanit, sans-serif', textDecoration: 'none', fontSize: '14px'
        }}>
          Vai al profilo
        </a>
      </div>
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);

  const [isLoginView, setIsLoginView] = useState(true);

  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [maestranzaToEdit, setMaestranzaToEdit] = useState(null);

  const [refreshKey, setRefreshKey] = useState(0);

  const [productions, setProductions] = useState([]);
  const [freelancers, setFreelancers] = useState([]);
  const [freelancerProfile, setFreelancerProfile] = useState(null);

  const [loading, setLoading] = useState(true);
  const [showAuthForm, setShowAuthForm] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showTermini, setShowTermini] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [error, setError] = useState(null);

  const [selectedRole, setSelectedRole] = useState('Tutti');
  const [uniqueRoles, setUniqueRoles] = useState([]);
  const [sortBy, setSortBy] = useState('scadenza');

  const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
  const [selectedFreelancerId, setSelectedFreelancerId] = useState(null);

  const [masterRoles, setMasterRoles] = useState({});


  // Dialog “inserisci ID”
  const [showMissingIdDialog, setShowMissingIdDialog] = useState(false);
  const [probingDone, setProbingDone] = useState(false);

  // --------- Recupero rapido del freelancerId dallo /freelancers/self ----------
  const fetchMyFreelancerId = async (tok) => {
    try {
      const data = await fetchJson('/freelancers/self', {
        headers: tok ? { Authorization: `Bearer ${tok}` } : undefined,
      });
      const id =
        (typeof data?.freelancer_id === 'number' ? data.freelancer_id : null) ??
        (typeof data?.id === 'number' ? data.id : null);
      if (id) {
        localStorage.setItem('freelancerId', String(id));
        setUser(prev => (prev ? { ...prev, freelancerId: id } : prev));
      }
      return id;
    } catch {
      return null;
    }
  };

  // ---------------- Helpers stato/colore/progresso ----------------
  const calculateProgressAndDays = (startDate, endDate) => {
    const today = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (Number.isNaN(end.getTime()) || Number.isNaN(start.getTime())) {
      return { status: 'Disponibile', progress: 0, daysRemaining: 0 };
    }
    if (today > end) return { status: 'Disponibile', progress: 100, daysRemaining: 0 };

    const timeRemaining = end - today;
    const daysRemaining = Math.ceil(timeRemaining / (1000 * 60 * 60 * 24));

    const totalDuration = end - start;
    const elapsedDuration = today - start;
    let progressPercentage = 0;
    if (totalDuration > 0) {
      progressPercentage = Math.min(100, Math.max(0, (elapsedDuration / totalDuration) * 100));
    } else if (elapsedDuration >= 0) {
      progressPercentage = 100;
    }

    let automaticStatus =
      progressPercentage >= 90 ? 'Disponibile' :
      progressPercentage >= 50 ? 'Presto Disponibile' :
      'Occupato';

    if (daysRemaining > 0 && daysRemaining <= 14 && today < end) {
      automaticStatus = 'Presto Disponibile';
    }

    return { status: automaticStatus, progress: progressPercentage, daysRemaining };
  };

  const getProgressBarCustomColor = (progress) => {
    if (progress >= 90) return '#8BC34A';
    if (progress >= 50) return '#FFC107';
    return '#F44336';
  };

  // ----------------- Login/Logout -----------------
  const handleLoginSuccess = async (authData) => {
    if (authData?.token) {
      localStorage.setItem('token', authData.token);
      setToken(authData.token);
    }
    if (authData?.user) {
      localStorage.setItem('user', JSON.stringify(authData.user));
      setUser({
        ...authData.user,
        freelancerId: authData.freelancerId ?? authData.user.freelancerId ?? null,
      });
    }
    if (authData?.pending) {
      setIsPending(true);
    }
    // salva subito se presente
    if (authData?.freelancerId) {
      localStorage.setItem('freelancerId', String(authData.freelancerId));
    }
    // FALLBACK: se è un freelance ma non abbiamo ancora l’ID, lo chiediamo al backend
    const isFreelance = (authData?.user?.user_type || '').toLowerCase() === 'freelance';
    const hasId = !!(authData?.freelancerId ?? authData?.user?.freelancerId);
    if (isFreelance && !hasId && authData?.token) {
      await fetchMyFreelancerId(authData.token);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('freelancerId');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setProductions([]);
    setFreelancers([]);
    setLoading(false);
    setIsLoginView(true);
    setIsEditProfileOpen(false);
    setIsPending(false);
    setIsRejected(false);
    setSelectedFreelancerId(null);
    setError(null);
  };

  // --------------- Risoluzione freelancerId dal backend ---------------
  const resolveFreelancerId = async (tok, u) => {
    // 0) se c'è in LS, usalo
    const lsId = Number(localStorage.getItem('freelancerId'));
    if (Number.isFinite(lsId) && lsId > 0) {
      setProbingDone(true);
      return lsId;
    }

    const tryFetch = async (path) => {
      try {
        const res = await fetch(`http://localhost:3001${path}`, {
          headers: { Authorization: `Bearer ${tok}` }
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (typeof data?.id === 'number') return data.id;
        if (typeof data?.freelancer_id === 'number') return data.freelancer_id;
        if (data?.profile && typeof data.profile.id === 'number') return data.profile.id;
        if (Array.isArray(data) && data[0] && typeof data[0].id === 'number') return data[0].id;
        return null;
      } catch {
        return null;
      }
    };

    if (!tok || !u) {
      setProbingDone(true);
      return null;
    }

    const jwtId = Number(u.id);
    const candidates = [];
    candidates.push(`/freelancers/self`);
    if (u.user_type === 'freelance' && Number.isFinite(jwtId)) {
      candidates.push(`/freelancers/${jwtId}`);
      candidates.push(`/users/${jwtId}`);
      candidates.push(`/utenti/${jwtId}`);
      candidates.push(`/profili/${jwtId}`);
      candidates.push(`/profile/${jwtId}`);
      candidates.push(`/profilo/${jwtId}`);
    }
    candidates.push(`/freelancers/current`);
    candidates.push(`/freelancers/me`);
    candidates.push(`/profile`);
    candidates.push(`/profilo`);

    for (const path of candidates) {
      const found = await tryFetch(path);
      if (found) {
        setProbingDone(true);
        return found;
      }
    }

    try {
      const res = await fetch(`http://localhost:3001/maestranze`, {
        headers: { Authorization: `Bearer ${tok}` }
      });
      if (res.ok) {
        const arr = await res.json();
        if (Array.isArray(arr) && arr.length > 0) {
          const pickIdFromProduction = (rec) => {
            if (!rec || typeof rec !== 'object') return null;
            const keys = [
              'freelancer_id', 'id_freelancer',
              'user_id', 'id_utente',
              'profilo_id', 'profile_id',
              'owner_id'
            ];
            for (const k of keys) {
              const v = rec[k];
              if (typeof v === 'number' && Number.isFinite(v)) return v;
              if (typeof v === 'string' && /^\d+$/.test(v)) return Number(v);
            }
            if (rec.freelancer && typeof rec.freelancer.id === 'number') return rec.freelancer.id;
            return null;
          };

          let id = null;
          for (let i = 0; i < Math.min(arr.length, 10); i++) {
            id = pickIdFromProduction(arr[i]);
            if (id) break;
          }
          setProbingDone(true);
          return id || null;
        }
      }
    } catch {
      // ignore
    }

    setProbingDone(true);
    return null;
  };

  // 🔧 Popola freelancerId nello stato (e LS) quando possiamo
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token || !user || user.user_type !== 'freelance') {
        setUser(prev => (prev ? { ...prev, freelancerId: null } : prev));
        setProbingDone(false);
        setShowMissingIdDialog(false);
        return;
      }

      // sync immediata da LS per evitare popup
      const lsId = Number(localStorage.getItem('freelancerId'));
      if (Number.isFinite(lsId) && lsId > 0) {
        setUser(prev => (prev ? { ...prev, freelancerId: lsId } : prev));
        setProbingDone(true);
        setShowMissingIdDialog(false);
        return;
      }

      const id = await resolveFreelancerId(token, user);
      if (!cancelled) {
        if (id != null) {
          localStorage.setItem('freelancerId', String(id));
        }
        setUser(prev => (prev ? { ...prev, freelancerId: id ?? null } : prev));
        if (id == null) setShowMissingIdDialog(true);
      }
    })();
    return () => { cancelled = true; };
  }, [token, user?.user_type]);

  // Carica profilo freelance per ProfileGate
  useEffect(() => {
    if (!token || !user || user.user_type !== 'freelance') return;
    fetchJson('/freelancers/self')
      .then(data => { if (data) setFreelancerProfile(data); })
      .catch(() => {});
  }, [token, user?.id]);

  // Carica profilo freelance per ProfileGate
  useEffect(() => {
    if (!token || !user || user.user_type !== 'freelance') return;
    fetchJson('/freelancers/self')
      .then(data => { if (data) setFreelancerProfile(data); })
      .catch(() => {});
  }, [token, user?.id]);

  // ----------------- Setup utente da token -----------------
  // ----------------- Setup utente da token (verificato col server) -----------------
useEffect(() => {
  let alive = true;
  (async () => {
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      // Verifica col backend usando /auth/me (valido per tutti i tipi utente)
      const me = await fetchJson('/auth/me');
      if (!alive) return;
      const userType = me?.user_type ?? null;
      setUser({
        id: me?.id ?? me?.user_id ?? null,
        user_type: userType,
        freelancerId: userType === 'freelance' ? (me?.freelancer_id ?? null) : null,
        email: me?.email ?? null,
        nome: me?.nome ?? null,
        cognome: me?.cognome ?? null,
        azienda: me?.azienda ?? null,
        company_id: me?.company_id ?? null,
        company_role: me?.company_role ?? null,
        is_premium: me?.is_premium ?? false,
        trial_expires_at: me?.trial_expires_at ?? null,
        subscription_until: me?.subscription_until ?? null,
        can_send_alerts: me?.can_send_alerts !== false,
      });
      // Carica profilo freelance per ProfileGate
      if (userType === 'freelance') {
        fetchJson('/freelancers/self')
          .then(data => { if (data) setFreelancerProfile(data); })
          .catch(() => {});
      }
      // Ripristina stato pending se il coordinatore non è ancora approvato
      if (userType === 'production_house' && me?.approved === false) {
        setIsPending(true);
      }
    } catch (e) {
      // Token scaduto/invalidato → logout pulito
      handleLogout();
    } finally {
      if (alive) setLoading(false);
    }
  })();
  return () => { alive = false; };
}, [token]);


  const isProductionHouse = user?.user_type === 'production_house';

  // ----------------- Fetch dashboard + masterRoles -----------------
  const fetchDashboardData = async () => {
    if (isEditProfileOpen || selectedFreelancerId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const endpoint = isProductionHouse ? '/vista-produzione' : '/maestranze';
    try {
      const [data, roles] = await Promise.all([
        fetchJson(endpoint),
        fetchJson('/ruoli'),
      ]);

      setMasterRoles(roles || {});

      if (isProductionHouse) {
        setFreelancers(data);
      } else {
        setProductions(data);
        const allRoles = data.flatMap(p => p.ruoli || []);
        const uniqueRolesList = [...new Set(allRoles)].sort();
        setUniqueRoles(['Tutti', ...uniqueRolesList]);
      }
      setError(null);
    } catch (e) {
      if (e.message === 'Forbidden: 403') {
        handleLogout();
      } else {
        setError("Impossibile caricare i dati: " + e.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user && token) {
      if (!isEditProfileOpen && !selectedFreelancerId) {
        fetchDashboardData();
      } else {
        setLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user_type, token, refreshKey, isEditProfileOpen, selectedFreelancerId]);

  // ----------------- Azioni -----------------
  const handleToggleOnline = async (id, currentStatus) => {
    try {
      await fetchJson(`/maestranze/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ is_online: !currentStatus })
      });
      setRefreshKey(prevKey => prevKey + 1);
    } catch (e) {
      setError("Errore nell'aggiornamento dello stato online: " + e.message);
    }
  };

  const handleEditClick = (maestranza) => {
    setMaestranzaToEdit(maestranza);
    setIsEditFormOpen(true);
  };

  // ----------------- Derivati lista freelance -----------------
  const filteredProductions = useMemo(() => {
    if (selectedRole === 'Tutti') return productions;
    return productions.filter(p => p.ruoli && p.ruoli.includes(selectedRole));
  }, [productions, selectedRole]);

  const sortedProductions = useMemo(() => {
    return [...filteredProductions].sort((a, b) => {
      if (sortBy === 'scadenza') return new Date(a.data_fine_contratto) - new Date(b.data_fine_contratto);
      if (sortBy === 'alfabetico') return `${a.cognome} ${a.nome}`.localeCompare(`${b.cognome} ${b.nome}`);
      if (sortBy === 'azienda') return (a.azienda || '').localeCompare(b.azienda || '');
      return 0;
    });
  }, [filteredProductions, sortBy]);

  // ----------------- CONTATTI (pubblica, no auth) -----------------
  if (typeof window !== 'undefined' && window.location.pathname === '/contatti') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ContactPage onBack={() => window.history.back()} />
      </ThemeProvider>
    );
  }

  // ----------------- PUBLIC REVIEW (no auth, no header) -----------------
  // La pagina /review/:slug deve essere accessibile via link pubblico protetto da password.
  // Usiamo un early-return per bypassare completamente la UI autenticata.
  const isPublicReview = typeof window !== 'undefined' && window.location.pathname.startsWith('/review/');
  if (isPublicReview) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/review/:id" element={<ReviewPlayerPage />} />
      </Routes>
    </BrowserRouter>
      </ThemeProvider>
    );
  }

  // ----------------- Reset password via link email (early return, funziona anche senza login) -----------------
  const resetToken = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('token');
  if (resetToken && window.location.pathname !== '/disponibile') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ResetPasswordPage onGoLogin={() => {
          window.history.replaceState({}, '', '/');
          setShowAuthForm(true);
          setIsLoginView(true);
        }} />
      </ThemeProvider>
    );
  }

  // ----------------- Termini e Condizioni -----------------
  if (showTermini) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TerminiPage onBack={() => setShowTermini(false)} />
      </ThemeProvider>
    );
  }

  // ----------------- Privacy Policy (pubblica, no login) -----------------
  if (typeof window !== 'undefined' && window.location.pathname === '/disponibile') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <DisponibilePage />
      </ThemeProvider>
    );
  }

  if (typeof window !== 'undefined' && window.location.pathname === '/admin') {
    if (!token) { window.location.href = '/'; return null; }
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AdminToolsPage />
      </ThemeProvider>
    );
  }

  if (typeof window !== 'undefined' && window.location.pathname === '/privacy') {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PrivacyPage onBack={() => window.history.back()} />
      </ThemeProvider>
    );
  }

  // ----------------- Schermata di Login / Landing -----------------
  if (!user && !loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieBanner />
        {showAuthForm
          ? (showForgotPassword
              ? <ResetPasswordPage onGoLogin={() => setShowForgotPassword(false)} />
              : isLoginView
                ? <LoginPage
                    onLoginSuccess={handleLoginSuccess}
                    onGoRegister={() => setIsLoginView(false)}
                    onForgotPassword={() => setShowForgotPassword(true)}
                  />
                : <RegistrationPage
                    onRegisterSuccess={handleLoginSuccess}
                    onGoLogin={() => setIsLoginView(true)}
                    onGoTermini={() => setShowTermini(true)}
                  />
            )
          : <LandingPage
              onGoLogin={() => { setShowAuthForm(true); setIsLoginView(true); }}
              onGoRegister={() => { setShowAuthForm(true); setIsLoginView(false); }}
            />
        }
      </ThemeProvider>
    );
  }

  // ----------------- Coordinatore in attesa di approvazione -----------------
  if (user && isPending) {
    const handleRefresh = async () => {
      try {
        const me = await fetchJson('/auth/me');
        if (me?.approved === true) {
          setIsPending(false);
        } else {
          // ancora in attesa — nessun feedback necessario, il bottone stesso indica lo stato
        }
      } catch (e) {
        // 404 = utente eliminato (rifiutato)
        setIsRejected(true);
      }
    };
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PendingApprovalPage onLogout={handleLogout} onRefresh={handleRefresh} rejected={isRejected} />
      </ThemeProvider>
    );
  }

  // ----------------- Loader / Error -----------------
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#1a1a1a', color: '#fff' }}>
        Caricamento...
      </Box>
    );
  }
  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#1a1a1a', color: 'red' }}>
        Errore: {error}
      </Box>
    );
  }

  // ----------------- UI Logged-in -----------------
  return (
    <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppShell
        user={user}
        trialDaysLeft={(() => {
          const exp = user?.trial_expires_at;
          if (!exp) return null;
          const diff = Math.ceil((new Date(exp) - new Date()) / (1000 * 60 * 60 * 24));
          return diff > 0 ? diff : 0;
        })()}
        subscriptionDaysLeft={(() => {
          const d = user?.subscription_until;
          if (!d) return null;
          const diff = Math.ceil((new Date(d) - new Date()) / (1000 * 60 * 60 * 24));
          return diff > 0 ? diff : null;
        })()}
        onLogout={handleLogout}
        onCloseEdit={() => setIsEditProfileOpen(false)}
        onClearSelection={() => setSelectedFreelancerId(null)}
        isEditProfileOpen={isEditProfileOpen}
        onEditProfile={() => {
          const lsId = Number(localStorage.getItem('freelancerId'));
          if (Number.isFinite(lsId) && lsId > 0) {
            setUser(prev => (prev ? { ...prev, freelancerId: lsId } : prev));
          }
          window.location.href = '/profile/edit';
        }}
      >

      {/* CONTENUTO DINAMICO */}
  <Routes>
  <Route path="/review/:id" element={<ReviewPlayerPage />} />
  <Route path="/review-admin/:id" element={<ReviewDashboard />} />
  <Route
    path="/messages"
    element={
      <DebugElement name="/messages">
        <MessagesPage currentUser={user} />
      </DebugElement>
    }
  />
    {/* Rotte nuove dei Piani */}
    <Route path="/piani" element={<PlansListPage />} />
    <Route path="/piani/new" element={<CreatePlanPage />} />
    <Route path="/eventi" element={<EventsPage />} />
    <Route path="/eventi/new" element={<EventNewPage />} />
    <Route path="/eventi/:id" element={<EventDetailPage />} />
    <Route path="/eventi/:id/edit" element={<EventEditPage />} />
    <Route path="/postplans/new" element={<CreatePlanPage />} />
    <Route path="/squadre" element={<SquadrePage />} />
    <Route path="/piani/:planId/editor" element={<PlanEditor />} />
    <Route path="/piani/:planId/review" element={<StepReview />} />
    <Route
  path="/piani/:planId/timeline"
  element={
    <DebugElement name="/piani/:planId/timeline">
      <div style={{ flex: 1, minHeight: 0, overflow: "hidden", padding: "16px", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
        <TimelineView />
      </div>
    </DebugElement>
  }
/>
    <Route path="/productions/:id" element={<ProductionDashboard />} />
    <Route path="/productions/:prodId/review/:revisionId/notes" element={<ReviewNotesPage />} />
    <Route path="/productions" element={<ProductionsList />} />
    <Route
  path="/productions/:id/postplan-assist"
  element={
    <DebugElement name="/productions/:id/postplan-assist">
      <PostPlanAssistPage />
    </DebugElement>
  }
/>
    <Route path="/review/:slug" element={<ReviewPublicPage />} />
    {console.log('[App render] freelancerProfile:', freelancerProfile, 'isProductionHouse:', isProductionHouse)}
    <Route path="/messages" element={<ProfileGate freelancerProfile={isProductionHouse ? null : freelancerProfile}><MessagesPage currentUser={user} /></ProfileGate>} />
    <Route path="/cerca" element={<ProfileGate freelancerProfile={isProductionHouse ? null : freelancerProfile}><CercaFreelancePage isProductionHouse={isProductionHouse} token={token} /></ProfileGate>} />
    <Route path="/notifiche" element={<ProfileGate freelancerProfile={isProductionHouse ? null : freelancerProfile}><NotifichePage /></ProfileGate>} />
    <Route path="/privacy" element={<PrivacyPage />} />
    <Route path="/contatti" element={<ContactPage />} />
    <Route path="/admin" element={<AdminToolsPage />} />
    <Route path="/premium" element={<PremiumPage user={user} />} />
    <Route path="/supervisor/alerts" element={<SupervisorAlertsPage />} />
    <Route path="/supervisor/coordinatori" element={<CoordinatorsPage token={token} />} />
    <Route path="/preferiti" element={<PreferitiPage token={token} />} />
    <Route path="/freelancer/:freelancerId" element={<FreelancerProfileRoute isProductionHouse={isProductionHouse} token={token} />} />
    <Route path="/radar" element={<RadarDisponibilitaPage />} />
    <Route path="/piano-di-post" element={<PianoDiPost />} />
    <Route path="/miei-crediti" element={<MieiCreditiPage />} />
    <Route path="/profile/edit" element={
      <EditProfileForm
        token={token}
        onProfileUpdated={() => {
          setRefreshKey(prev => prev + 1);
          window.history.back();
        }}
        onCancel={() => window.history.back()}
      />
    } />
    <Route
  path="/postplans/:id"
  element={
    <DebugElement name="/postplans/:id">
      <PostPlanTimelinePage />
    </DebugElement>
  }
/>
   
    <Route
  path="/postplans/:id/wizard"
  element={
    <DebugElement name="/postplans/:id/wizard">
      <PostPlanWizardPage />
    </DebugElement>
  }
/>

    {/* Rotta di default: dashboard attuale */}
    <Route
      path="*"
      element={(() => {
        if (selectedFreelancerId) {
          return <FreelancerDetailView freelancerId={selectedFreelancerId} token={token} />;
        }
        if (isEditProfileOpen) {
          return (
            <EditProfileForm
              token={token}
              onProfileUpdated={() => {
                setIsEditProfileOpen(false);
                setRefreshKey(prev => prev + 1);
              }}
              onCancel={() => setIsEditProfileOpen(false)}
            />
          );
        }
        if (isProductionHouse) {
          return (
            <>
              <AlertsBoard token={token} user={user} masterRoles={masterRoles} />
              <ProductionHouseView
                user={user}
                freelancers={freelancers}
                masterRoles={masterRoles}
                onSelectFreelancer={(id) => setSelectedFreelancerId(id)}
                token={token}
              />
            </>
          );
        }
        if (user.user_type === 'freelance') {
          return (
            <FreelancerProfile
              showAlerts={true}
              onEditProfile={() => setIsEditProfileOpen(true)}
            />
          );
        }
        // utente non loggato → landing
        return <LandingPage />;
      })()}
    />
  </Routes>


      {/* DIALOG: CREA PRODUZIONE */}
      <Dialog
        open={isCreateFormOpen}
        onClose={() => setIsCreateFormOpen(false)}
        PaperProps={{ sx: { backgroundColor: '#fff', color: '#000' } }}
      >
        <DialogContent>
          <CreateMaestranzaForm
            onMaestranzaCreated={() => {
              fetchDashboardData();
              setIsCreateFormOpen(false);
            }}
            token={token}
            masterRoles={masterRoles}
          />
        </DialogContent>
      </Dialog>

      {/* DIALOG: EDIT PRODUZIONE */}
      <Dialog
        open={isEditFormOpen}
        onClose={() => setIsEditFormOpen(false)}
        PaperProps={{ sx: { backgroundColor: '#fff', color: '#000' } }}
      >
        <DialogContent>
          {maestranzaToEdit && (
            <EditMaestranzaForm
              maestranza={maestranzaToEdit}
              onMaestranzaUpdated={() => {
                fetchDashboardData();
                setIsEditFormOpen(false);
              }}
              token={token}
              onClose={() => setIsEditFormOpen(false)}
              masterRoles={masterRoles}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* DIALOG: richiesta ID profilo (una tantum) */}
      {(() => {
        const lsFreelancerId = Number(localStorage.getItem('freelancerId'));
        const shouldOpen =
          showMissingIdDialog &&
          isEditProfileOpen &&
          user?.user_type === 'freelance' &&
          user?.freelancerId == null &&
          !(Number.isFinite(lsFreelancerId) && lsFreelancerId > 0) &&
          probingDone;

        return (
          <MissingProfileIdDialog
            open={shouldOpen}
            onClose={() => setShowMissingIdDialog(false)}
            onSave={(n) => {
              localStorage.setItem('freelancerId', String(n));
              setUser(prev => (prev ? { ...prev, freelancerId: n } : prev));
              setShowMissingIdDialog(false);
            }}
          />
        );
      })()}

      </AppShell>
      <CookieBanner />
    </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;